/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './threadgate.defs.js'
export { main as default } from './threadgate.defs.js'
